import _ from 'lodash'
import { RefreshAppsOptions } from './types'

const aggregateArray = (items?: Array<string>, aggItems?: Array<string>) => {
	return _.compact(_.uniq((aggItems || []).concat(items || [])))
}

export const aggregateRefreshParams = (livePreviewRequests: Array<RefreshAppsOptions>): RefreshAppsOptions =>
	livePreviewRequests.reduce(
		(agg, options) => ({
			apps: aggregateArray(options.apps, agg.apps),
			compsIdsToReset: aggregateArray(options.compsIdsToReset, agg.compsIdsToReset),
			shouldFetchData: agg.shouldFetchData || options.shouldFetchData,
			controllersToRefresh: aggregateArray(options.controllersToRefresh, agg.controllersToRefresh),
		}),
		{} as RefreshAppsOptions
	)
